// Shared no-op handler for actions that aren't wired up yet (menu placeholders,
// pending TODOs). De-dupes the repeated `const noop = () => {}` definitions.
export const noop = () => {};
